module.exports = __webpack_public_path__ + "static/MR_APR19_PeterPan_600x600px-38920010c512874016c90f0155dcb173.jpg";